import React, { memo } from 'react'
import tw from 'twin.macro'
import { Tooltip, Typography } from '@mui/material'
import { colors } from 'src/theme'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  helperLabel: string
  limitReachedText: string
  timeRemaining: string
  isLimitReached: boolean
}

const ResendCooldownHintComponent = ({
  helperLabel,
  limitReachedText,
  timeRemaining,
  isLimitReached,
}: Props) => {
  return (
    <Typography
      variant="body2"
      css={tw`mt-1.5 flex items-center justify-center gap-1`}
      color={colors.SHADES_GREY_400}
    >
      {`${helperLabel} available again in ${timeRemaining}`}
      <Tooltip
        color="black"
        componentsProps={{ tooltip: { sx: { maxWidth: 275, paddingX: 2 } } }}
        title={
          <div>
            <Typography css={tw`mb-1`} variant="h6" color={colors.SHADES_GREY_200}>
              Resend unavailable
            </Typography>
            {isLimitReached ? (
              <Typography variant="body2" color={colors.SHADES_GREY_300}>
                {limitReachedText}
              </Typography>
            ) : (
              <Typography variant="body2" color={colors.SHADES_GREY_300}>
                {`Resend is available again in ${timeRemaining}.`}
                <br />
                Maximum of 2 resends per 24 hours.
              </Typography>
            )}
          </div>
        }
        placement="top"
      >
        <span
          css={tw`inline-flex cursor-pointer`}
          tabIndex={0}
          aria-label="Resend unavailable details"
          data-testid="contractor-actions-resend-invite-info"
        >
          <GSIcon iconName="gs_icon_circle_info_2" width={20} height={20} />
        </span>
      </Tooltip>
    </Typography>
  )
}

export const ResendCooldownHint = memo(ResendCooldownHintComponent)
